import { Map, List } from 'immutable'

export default List([
  Map({ label: 'None', value: '' }),
  Map({ label: 'Active production (series)', value: 'active-production' }),
])
